import { Link } from "react-router-dom";
import SectionHeading from "@/components/feature/SectionHeading";
import ExposeCard from "@/components/feature/ExposeCard";
import { exposeCases } from "@/mocks/exposes";
import type { ExposeCase } from "@/types/content";

function FeaturedExpose({ item }: { item: ExposeCase }) {
  return (
    <article className="h-full">
      <Link
        to={`/expose/${item.id}`}
        className="group flex h-full flex-col overflow-hidden rounded-lg border border-background-200 bg-background-100 transition-colors hover:border-primary-300"
      >
        <div className="relative aspect-[16/10] w-full overflow-hidden bg-background-200">
          <img
            src={item.cover}
            alt={item.coverAlt}
            className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-105"
          />
          <span className="absolute left-4 top-4 rounded-full bg-primary-500 px-3 py-1 text-xs font-medium text-background-50">
            {item.category}
          </span>
        </div>
        <div className="flex flex-1 flex-col p-6 md:p-7">
          <p className="mb-3 flex items-center gap-2 text-xs tracking-[0.16em] text-primary-600">
            <i className="ri-flashlight-line" aria-hidden="true" />
            头条复盘
          </p>
          <h3 className="font-heading text-xl font-bold leading-8 text-foreground-950 transition-colors group-hover:text-primary-700 md:text-2xl">
            {item.title}
          </h3>
          <p className="mt-4 flex-1 text-sm leading-7 text-foreground-600">
            {item.summary}
          </p>
          <div className="mt-6 flex flex-wrap items-center gap-x-5 gap-y-2 border-t border-background-300 pt-5 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-fire-line text-accent-500" aria-hidden="true" />
              {item.heat} 热度
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-time-line" aria-hidden="true" />
              {item.readMinutes} 分钟阅读
            </span>
            <span>{item.date}</span>
          </div>
        </div>
      </Link>
    </article>
  );
}

export default function LatestExposes() {
  const [featured, ...rest] = exposeCases;

  return (
    <section className="mx-auto w-full max-w-content px-4 py-16 md:px-8 md:py-20">
      <SectionHeading
        eyebrow="最新爆料"
        title="正在被拆解的骗局与乱象"
        description="每一条都来自真实的踩坑路径，我们只保留可复现的套路与可执行的避坑建议。"
        action={{ label: "查看全部爆料", path: "/expose" }}
      />
      <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
        <FeaturedExpose item={featured} />
        <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
          {rest.slice(0, 4).map((item) => (
            <ExposeCard key={item.id} item={item} />
          ))}
        </div>
      </div>
    </section>
  );
}